export default "__VITE_ASSET__BYcpdj89__"